import { providerList } from '@blax-modules/base-front-end/resources/js/utilities/providers';

import { Home } from './parts/home.js';
providerList.instantiate('Home', Home);

import { Menu } from './parts/menu.js';
providerList.instantiate('Menu', Menu);

import { Header } from './parts/header.js';
providerList.instantiate('Header', Header);

import { tns } from "tiny-slider/src/tiny-slider";

import { FooterAlignment } from './parts/FooterAlignment.js';

import { Plans } from './parts/plans.js';

import "./parts/dynamic_blocks";

import "./parts/images/verysimple-parallax";


/**
 * Used in dynamic block image slider
 */

let imageSliderEl = document.querySelector('.image-slider');
if(imageSliderEl != null){

    let sliderAUtoplay = (imageSliderEl.getAttribute('data-autoplay') == 'auto') ? true : false;
    let sliderSpeed = imageSliderEl.getAttribute('data-speed');

    const IMAGE_SLIDER = {
        container: ".image-slider",
        items: 1,
        slideBy: "page",
        mouseDrag: true,
        swipeAngle: false,
        controls: false,
        autoplayTimeout: sliderSpeed,
        autoplay: sliderAUtoplay,
        navPosition: "bottom"
    }

    document.addEventListener('DOMContentLoaded', () => {
        let imageSliderEl = document.querySelector('.image-slider');
        let imageSlider = tns(IMAGE_SLIDER);
    })
}

new FooterAlignment();
new Plans();

